import { create } from 'zustand';

type Theme = 'light' | 'dark' | 'purple' | 'forest' | 'ocean' | 'sunset' | 'rose' | 'amber' | 'teal';

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  theme: 'teal',
  setTheme: (theme) => {
    document.documentElement.setAttribute('data-theme', theme);
    set({ theme });
  },
}));